import { defineComponent, reactive } from 'vue';
import { GRAPH_INTERVAL } from '@hems/util/src/constant';
import { MainTitle, ReportTabList } from '@/components';
import { ConsumptionContainer } from '@/containers';
export default defineComponent({
    name: 'Consumption',
    components: {
        MainTitle,
        ReportTabList,
        ConsumptionContainer,
    },
    setup() {
        const state = reactive({
            tabname: GRAPH_INTERVAL.HOURLY,
        });
        return { state, GRAPH_INTERVAL };
    },
});
